/**
 * @generated SignedSource<<ec0f24ef63002ec34e766ecf8ddd3e24>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type churnPage_Query$variables = {
  from?: string | null | undefined;
  to?: string | null | undefined;
};
export type churnPage_Query$data = {
  readonly churn: {
    readonly cohorts: ReadonlyArray<{
      readonly cohort: string;
      readonly logoRetention: ReadonlyArray<number>;
      readonly revenueRetention: ReadonlyArray<number>;
      readonly size: number;
    }>;
    readonly grossRevenueChurn: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly logoChurn: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly netRevenueChurn: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
  };
  readonly churnBreakdown: {
    readonly accountSize: ReadonlyArray<{
      readonly activeCustomerMonths: number;
      readonly avgMonthlyLogoChurn: number;
      readonly bucket: string;
      readonly churnedCustomers: number;
      readonly churnedMrr: number;
      readonly monthlyChurnedMrr: ReadonlyArray<{
        readonly month: string;
        readonly value: number | null | undefined;
      }>;
    }>;
    readonly plan: ReadonlyArray<{
      readonly activeCustomerMonths: number;
      readonly avgMonthlyLogoChurn: number;
      readonly bucket: string;
      readonly churnedCustomers: number;
      readonly churnedMrr: number;
      readonly monthlyChurnedMrr: ReadonlyArray<{
        readonly month: string;
        readonly value: number | null | undefined;
      }>;
    }>;
    readonly tenure: ReadonlyArray<{
      readonly activeCustomerMonths: number;
      readonly avgMonthlyLogoChurn: number;
      readonly bucket: string;
      readonly churnedCustomers: number;
      readonly churnedMrr: number;
      readonly monthlyChurnedMrr: ReadonlyArray<{
        readonly month: string;
        readonly value: number | null | undefined;
      }>;
    }>;
  };
};
export type churnPage_Query = {
  response: churnPage_Query$data;
  variables: churnPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "from"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "to"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "from",
    "variableName": "from"
  },
  {
    "kind": "Variable",
    "name": "to",
    "variableName": "to"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cohort",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoRetention",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenueRetention",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v8 = [
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bucket",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "churnedCustomers",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "churnedMrr",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activeCustomerMonths",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avgMonthlyLogoChurn",
  "storageKey": null
},
v14 = [
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "MetricPoint",
    "kind": "LinkedField",
    "name": "monthlyChurnedMrr",
    "plural": true,
    "selections": (v8/*: any*/),
    "storageKey": null
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v16 = [
  (v6/*: any*/),
  (v7/*: any*/),
  (v15/*: any*/)
],
v17 = [
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "MetricPoint",
    "kind": "LinkedField",
    "name": "monthlyChurnedMrr",
    "plural": true,
    "selections": (v16/*: any*/),
    "storageKey": null
  },
  (v15/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "churnPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Churn",
        "kind": "LinkedField",
        "name": "churn",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Cohort",
            "kind": "LinkedField",
            "name": "cohorts",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "grossRevenueChurn",
            "plural": true,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "netRevenueChurn",
            "plural": true,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "logoChurn",
            "plural": true,
            "selections": (v8/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ChurnBreakdown",
        "kind": "LinkedField",
        "name": "churnBreakdown",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChurnBucket",
            "kind": "LinkedField",
            "name": "tenure",
            "plural": true,
            "selections": (v14/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ChurnBucket",
            "kind": "LinkedField",
            "name": "accountSize",
            "plural": true,
            "selections": (v14/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ChurnBucket",
            "kind": "LinkedField",
            "name": "plan",
            "plural": true,
            "selections": (v14/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "churnPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Churn",
        "kind": "LinkedField",
        "name": "churn",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Cohort",
            "kind": "LinkedField",
            "name": "cohorts",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "grossRevenueChurn",
            "plural": true,
            "selections": (v16/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "netRevenueChurn",
            "plural": true,
            "selections": (v16/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "logoChurn",
            "plural": true,
            "selections": (v16/*: any*/),
            "storageKey": null
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ChurnBreakdown",
        "kind": "LinkedField",
        "name": "churnBreakdown",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChurnBucket",
            "kind": "LinkedField",
            "name": "tenure",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ChurnBucket",
            "kind": "LinkedField",
            "name": "accountSize",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ChurnBucket",
            "kind": "LinkedField",
            "name": "plan",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "35f200db0076344816ca90b1b691eac3",
    "id": null,
    "metadata": {},
    "name": "churnPage_Query",
    "operationKind": "query",
    "text": "query churnPage_Query(\n  $from: String\n  $to: String\n) {\n  churn(from: $from, to: $to) {\n    cohorts {\n      cohort\n      size\n      logoRetention\n      revenueRetention\n      id\n    }\n    grossRevenueChurn {\n      month\n      value\n      id\n    }\n    netRevenueChurn {\n      month\n      value\n      id\n    }\n    logoChurn {\n      month\n      value\n      id\n    }\n    id\n  }\n  churnBreakdown(from: $from, to: $to) {\n    tenure {\n      bucket\n      churnedCustomers\n      churnedMrr\n      activeCustomerMonths\n      avgMonthlyLogoChurn\n      monthlyChurnedMrr {\n        month\n        value\n        id\n      }\n      id\n    }\n    accountSize {\n      bucket\n      churnedCustomers\n      churnedMrr\n      activeCustomerMonths\n      avgMonthlyLogoChurn\n      monthlyChurnedMrr {\n        month\n        value\n        id\n      }\n      id\n    }\n    plan {\n      bucket\n      churnedCustomers\n      churnedMrr\n      activeCustomerMonths\n      avgMonthlyLogoChurn\n      monthlyChurnedMrr {\n        month\n        value\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b5ea7175bc0fe186ca5b42ae2bc938a8";

export default node;
